import React from 'react'
import { Row, Col } from 'react-bootstrap'

const SkillDescription = () => {
    return (
        <>
            <div className='p-80-0 skilldescription' id='Experience'>
                <div className='container '>
                    <Row className='align-items-center'>
                        <Col xl={4} lg={4}  md={5}  >
                            <div className="education-box border-radius">
                                <div className="educontion">
                                    <p className='pill d-inline-block'>2018-2022</p>
                                    <h2 className='fw-700'>Front-end Engineer</h2>
                                    <h3 className='main-gray-text f-16'>International Design Institute</h3>
                                </div>
                                <hr />
                                <div className="educontion"> <p className='pill d-inline-block'>2015-2017</p>
                                    <h2 className='fw-700'>Graphic Designer</h2>
                                    <h3 className='main-gray-text f-16'>HRK Design Institute</h3>
                                </div>
                                <hr />
                                <div className="educontion">
                                    <p className='pill d-inline-block'>2012-2014</p>
                                    <h2 className='fw-700'>Visual Designer</h2>
                                    <h3 className='main-gray-text f-16'>HRK Design Institute</h3>
                                </div>
                            </div>
                        </Col>
                        <Col xl={8} lg={8} md={7}>
                            <h2 className="text-center title font-cormorant  ">
                                Experience
                            </h2>
                            <p className='f-18 lh-35 text-center'>
                                There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable.
                            </p>
                            <div className='text-center'>
                                <button class="send-btn button">Read More</button>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    )
}

export default SkillDescription